import Stepper from './Stepper.component';

export default Stepper;
